module.exports = __webpack_public_path__ + "images/licensed-header@2x.95bbae7f65859b75f77c4ce18ceee8ff.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/licensed-header@2x.jpg
// module id = 1011
// module chunks = 0